const preventDefault = (e) => {
  e = e || window.event;
  if (e.preventDefault) {
    e.preventDefault();
  }
  e.returnValue = false;
}

const preventDefaultForScrollKeys = (e) => {
  if ({37: 1, 38: 1, 39: 1, 40: 1}[e.keyCode]) {
    preventDefault(e);
    return false;
  }
}

var store = {
  scrollTop:0,
  lockedScroll: 0,
  linksCount: 0,

  setGlobalVars() {
    this.windowHeight = window.innerHeight;
    this.windowWidth = window.innerWidth;

    this.setVisibleHeightProperty();
  },
  setVisibleHeightProperty() {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    const vh = this.windowHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  },
  bodyIsLocked() {
    return document.body.classList.contains('locked') || this.lockedScroll !== 0;
  },
  lockBody() {
    this.lockedScroll = this.scrollTop;
    document.body.classList.add('locked');
    // document.querySelector('.main').scrollTop = this.lockedScroll;
  },
  unlockBody() {
    document.body.classList.remove('locked');
    this.lockedScroll = 0;
    // window.scrollTo(0, this.lockedScroll);
  },
  scrollToTop() {
    document.querySelector('main').scrollTop = 0;
  },

  disableScrollHard() {
    document.documentElement.style.overflowY = 'hidden';
    window.onwheel = preventDefault;
    window.onmousewheel = document.onmousewheel = preventDefault;
    window.ontouchmove = preventDefault;
    document.onkeydown = preventDefaultForScrollKeys;
  },

  enableScrollHard() {
    document.documentElement.style.overflowY = null;
    window.onmousewheel = document.onmousewheel = null;
    window.onwheel = null;
    window.ontouchmove = null;
    document.onkeydown = null;
  },
};
export default store;



// WEBPACK FOOTER //
// ./scripts/util/store.js